module.exports = __webpack_public_path__ + "img/sailboat.2ab4b3b6.svg";